import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../../axiosInterceptor";
import { useFormik } from "formik";
import CodeEditor from "../../Components/CodeEditor";
import ImageUploadDragAndDrop from "../../Components/ImageUploadDragAndDrop";

const WebSetting = () => {
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      companyName: "",
      address: "",
      email: "",
      contactNo: "",
      whatsAppNo: "",
      mapUrl: "",
      host: "",
      port: "",
      headerLogo: null,
      footerLogo: null,
      metaTitle: "",
      metaKeywords: "",
      metaDescription: "",
    },

    onSubmit: async (values) => {
      setLoading(true);
      try {
        const formData = new FormData();
        Object.entries(values).forEach(([key, value]) => {
          if (
            value !== null &&
            value !== "" &&
            key !== "_id" &&
            key !== "createdAt" &&
            key !== "updatedAt" &&
            key !== "__v"
          ) {
            if (key === "headerLogo" || key === "footerLogo") {
              if (value instanceof File) {
                formData.append(key, value);
              }
            } else {
              formData.append(key, value);
            }
          }
        });

        await axiosInstance.post("settings/updateSettings", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        toast.success("Website settings updated successfully");
      } catch (err) {
        toast.error(err?.response?.data?.message || "Update failed");
      } finally {
        setLoading(false);
      }
    },
  });

  const {
    values,
    handleChange,
    handleBlur,
    handleSubmit,
    setFieldValue,
    errors,
    touched,
    setValues,
    initialValues,
  } = formik;
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get("settings/getSettings");

        if (response?.data?.data) {
          const { _id, createdAt, updatedAt, ...safeData } = response.data.data;

          setValues({
            ...initialValues,
            ...safeData,
            headerLogo: safeData.headerLogo || null,
            footerLogo: safeData.footerLogo || null,
          });
        }
      } catch (error) {
        toast.error("Failed to fetch configuration");
      }
    };

    fetchData();
  }, [setValues, initialValues]);

  return (
    <div className="content-wrapper">
      <div className="page-header">
        <h3 className="page-title">Website Settings</h3>
      </div>

      <div className="card">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row mb-4">
              <div className="col-md-4">
                <label
                  className="form-label fw-semibold "
                  htmlFor="companyName"
                >
                  Company Name
                </label>
                <input
                  type="text"
                  id="companyName"
                  name="companyName"
                  className="form-control border border-dark"
                  value={values.companyName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter Company Name"
                />
              </div>

              <div className="col-md-4 mb-2">
                <label className="form-label fw-semibold" htmlFor="email">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className="form-control border border-dark"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter Email"
                />
              </div>

              <div className="col-md-4 mb-2">
                <label className="form-label fw-semibold" htmlFor="whatsAppNo">
                  Whatsapp No
                </label>
                <input
                  type="text"
                  id="whatsAppNo"
                  name="whatsAppNo"
                  className="form-control border border-dark"
                  value={values.whatsAppNo}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter Whatsapp No"
                />
              </div>

              <div className="col-md-4 mb-2">
                <label className="form-label fw-semibold">Contact No</label>
                <CodeEditor
                  placeholder={"Enter Contact No"}
                  value={values.contactNo}
                  onChange={(val) => setFieldValue("contactNo", val)}
                  className="form-control border border-dark"
                />
              </div>

              <div className="col-md-4 mb-2">
                <label className="form-label fw-semibold">Address</label>
                <CodeEditor
                  placeholder={"Enter Address"}
                  value={values.address}
                  onChange={(val) => setFieldValue("address", val)}
                  className="form-control border border-dark"
                />
              </div>

              <div className="col-md-4 mb-2">
                <label className="form-label fw-semibold" htmlFor="mapUrl">
                  Contact Map URL
                </label>
                <textarea
                  name="mapUrl"
                  id="mapUrl"
                  rows={13}
                  className="form-control border border-dark"
                  value={values.mapUrl}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Enter Contact Map URL"
                />
              </div>
              <div className="col-md-6">
                <ImageUploadDragAndDrop
                  id="website-setting-headerLogo"
                  label={`Header Logo`}
                  value={values.headerLogo}
                  onChange={(file) => setFieldValue("headerLogo", file)}
                  error={errors.headerLogo}
                  touched={touched.headerLogo}
                />
              </div>

              <div className="col-md-6">
                <ImageUploadDragAndDrop
                  id="website-setting-footerLogo"
                  label={`Footer Logo`}
                  value={values.footerLogo}
                  onChange={(file) => setFieldValue("footerLogo", file)}
                  error={errors.footerLogo}
                  touched={touched.footerLogo}
                />
              </div>

              <div className="col-sm-4">
                <div className="form-group">
                  <label htmlFor="blog-metaTitle" className="col-form-label ">
                    Meta Title
                  </label>
                  <input
                    type="text"
                    className="form-control  border border-dark"
                    id="blog-metaTitle"
                    name="metaTitle"
                    placeholder="Enter meta title"
                    value={values.metaTitle}
                    onChange={handleChange}
                  />
                  {touched.metaTitle && errors.metaTitle && (
                    <small className="text-danger">{errors.metaTitle}</small>
                  )}
                </div>
              </div>

              <div className="col-sm-4">
                <div className="form-group">
                  <label
                    htmlFor="blog-metaKeywords"
                    className="col-form-label "
                  >
                    Meta Keywords
                  </label>
                  <input
                    type="text"
                    className="form-control  border border-dark"
                    id="blog-metaKeywords"
                    name="metaKeywords"
                    placeholder="Enter meta keywords"
                    value={values.metaKeywords}
                    onChange={handleChange}
                  />
                  {touched.metaKeywords && errors.metaKeywords && (
                    <small className="text-danger">{errors.metaKeywords}</small>
                  )}
                </div>
              </div>
              <div className="col-sm-4">
                <div className="form-group">
                  <label
                    htmlFor="blog-metaDescription"
                    className="col-form-label"
                  >
                    Meta Description
                  </label>

                  <textarea
                    className="form-control  border border-dark"
                    id="blog-metaDescription"
                    name="metaDescription"
                    placeholder="Enter meta description"
                    value={values.metaDescription}
                    onChange={handleChange}
                    rows={1}
                  />

                  {touched.metaDescription && errors.metaDescription && (
                    <small className="text-danger">
                      {errors.metaDescription}
                    </small>
                  )}
                </div>
              </div>
            </div>

            <div className="text-center mt-4">
              <button
                type="submit"
                className="btn btn-primary px-4"
                disabled={loading}
              >
                {loading ? "Saving..." : "Update Settings"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default WebSetting;
